<template>
    <div>
        <span v-if="type === 'greater'">&gt; </span>
        <span v-if="type === 'smaller'">&lt; </span>
        <span v-if="from !== ''">{{ from }}</span>
        <span v-if="type === 'fromTo' && to !== ''"> - {{ to }}</span>
    </div>
</template>

<script>
export default {
    name: "LengthDisplay",
    props: {
        type: String,
        from: [String,Number],
        to:   [String,Number]
    },

}
</script>

<style scoped>

</style>